import { render, staticRenderFns } from "./ChatInactivePreview.vue?vue&type=template&id=cc8ee8b6"
import script from "./ChatInactivePreview.vue?vue&type=script&lang=js"
export * from "./ChatInactivePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports